import React, {Component} from "react";
import {Link} from "react-router";
import {FormattedDate, FormattedTime} from "react-intl";
import "./DashboardPanel.css"

class LastBuildStatusPanel extends Component {
    describeLastBuild() {
        const lastBuildStatus = this.props.status;

        const lastBuildPanel = {
            className: '',
            title: '',
            subtitle: '',
            description: ''
        };

        switch (lastBuildStatus.outcome) {
            case 'LOADING':
                lastBuildPanel.className = 'panel-default';
                lastBuildPanel.title = 'Job Status';
                lastBuildPanel.subtitle = 'Loading last job status';
                lastBuildPanel.description = '';
                break;

            case 'SUCCEEDED':
                lastBuildPanel.className = 'panel-success';
                lastBuildPanel.title = 'Last Job Successful';
                lastBuildPanel.subtitle = 'Execution of the last job was successful.';
                lastBuildPanel.description = this.describeJobExecution(lastBuildStatus);
                break;

            case 'FAILED':
                lastBuildPanel.className = 'panel-warning';
                lastBuildPanel.title = 'Last Job Failed';
                lastBuildPanel.subtitle = 'Execution of the last job failed.';
                lastBuildPanel.description = this.describeJobExecution(lastBuildStatus);
                break;

            case 'NOT_RUN':
                lastBuildPanel.className = 'panel-info';
                lastBuildPanel.title = 'No Jobs Run';
                lastBuildPanel.subtitle = 'No jobs have been run yet.';
                lastBuildPanel.description = 'Set up some actions or trigger a job from Slack.';
                break;

            default:
                lastBuildPanel.className = 'panel-danger';
                lastBuildPanel.title = 'Last Job Unknown';
                lastBuildPanel.subtitle = 'The status of the last job execution is unknown.';
                lastBuildPanel.description = '';
                break;
        }
        return lastBuildPanel;
    }

    /**
     * @param {*} lastBuild
     */
    describeJobExecution(lastBuild) {
        const executionDate = new Date(lastBuild.eventDate);

        return (
            <span>
                <i>@{lastBuild.triggeredBy}</i> triggered
                {' '}the <strong>{lastBuild.job}</strong> {lastBuild.driver} job
                {' '}in <i>#{lastBuild.channel}</i>

                {' '}at <FormattedTime value={executionDate}/>
                {' '}on <FormattedDate value={executionDate}
                                       day="numeric"
                                       month="long"
                                       year="numeric"/>.

                {' '}{lastBuild.outcome === 'SUCCEEDED' ? 'It was successful.' : lastBuild.outcome === 'FAILED' ? 'It didn\'t go well' : ''}
            </span>
        );
    }

    render() {
        const lastBuildPanel = this.describeLastBuild();

        return (

            <div className="col-sm-6">
                <div className={`panel panel-bold ${lastBuildPanel.className}`}>
                    <div className="panel-body dashboard-panel p-b">
                        <h3 className="m-y-0">{lastBuildPanel.title}</h3>
                        <p>{lastBuildPanel.subtitle}</p>
                        <hr/>

                        <div className="row">
                            <div className="col-md-7">
                                <p>{lastBuildPanel.description}</p>
                            </div>
                            <div className="visible-xs visible-sm m-t"/>
                            <div className="col-md-5 dashboard-panel-button">
                                {this.props.status.outcome === 'SUCCEEDED' ?
                                    <Link to="/bot/builds" className="btn btn-default">Show Build History</Link> :
                                    <Link to="/bot/actions" className="btn btn-default">Edit Job Actions</Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LastBuildStatusPanel.propTypes = {
    status: React.PropTypes.object
};

export default LastBuildStatusPanel;



// WEBPACK FOOTER //
// ./src/modules/common/LastBuildStatusPanel.js